module.exports = __webpack_public_path__ + "static/media/2.634d7efd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/galaxyRewards/2.png
// module id = 2068
// module chunks = 0